// extracted by mini-css-extract-plugin
export default {"poweredByUnibuddy":"IcHAhoYYouyVEplE2ndC"};